import { render, staticRenderFns } from "./business-info.vue?vue&type=template&id=09f9c688&"
import script from "./business-info.vue?vue&type=script&lang=js&"
export * from "./business-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports